<template>
    <v-container fluid>
        <v-row>
            <!-- Sidebar -->
            <v-col cols="12" md="3">
                <v-card class="pa-4">
                    <v-card-title>Options</v-card-title>
                    <v-divider></v-divider>
                    <v-select v-model="selectedOption" label="Page Type" dense outlined :items="options"></v-select>

                    <!-- Dropdown with a Placeholder -->
                    <v-select
                        v-model="userTierSelectedOption"
                        :items="tierOptions"
                        label="User Tier"
                        placeholder="Select User Tier"
                        item-text="label"
                        item-value="value"
                        dense
                        outlined/>

                    <v-text-field label="Input 1" dense outlined></v-text-field>
                    <v-text-field label="Input 2" dense outlined></v-text-field>
                </v-card>
            </v-col>
            <v-col cols="12" md="9">
                <v-text-field
                    v-model="xmlIdsInput"
                    label="XML ID(s)"
                    outlined
                    dense
                    hide-details
                    class="mb-2"
                ></v-text-field>

                <v-btn
                    :block="isMobilePort"
                    color="primary"
                    @click="loadSection"
                    :loading="isLoading"
                    class="mb-2"
                >
                    Load Section
                </v-btn>

                <default-content-section-controller
                    :xmlIdsQuery="xmlIdsQuery"
                    @loading="setLoading"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import DefaultContentSectionController from "../../components/content-section/DefaultContentSectionController.vue";
import Mobile from "../../components/inc/mixins/mobile";

export default {
    components: { DefaultContentSectionController },
    mixins: [Mobile],
    data() {
        return {
            xmlIdsInput: '', // bound to input field
            xmlIdsQuery: {},     // passed to child only on button click
            isLoading: false,
            options: ['General'],
            selectedOption: 'General',
            userTierSelectedOption: null, // Bind to v-select for User Tier
            tierOptions: [
                {label: 'Select User Tier', value: null},
                {label: 'Basic', value: 'basic'},
                {label: 'Premium',value: 'premium'}
            ],
        };
    },
    mounted() {
        const url = new URL(window.location.href);
        const raw = url.searchParams.get("xmlIds");

        if (raw) {
            try {
                const parsed = JSON.parse(decodeURIComponent(raw));
                this.xmlIdsInput = parsed.xmlIds || "";
                this.userTierSelectedOption = parsed.userTierEmulation || null;
                this.xmlIdsQuery = parsed;
            } catch (e) {
                console.error("Failed to parse xmlIds query:", e);
            }
        }
    },
    watch: {
        xmlIdsQuery: {
            handler(newVal) {
                const url = new URL(window.location.href);
                const serialized = encodeURIComponent(JSON.stringify(newVal));
                url.searchParams.set("xmlIds", serialized);
                window.history.replaceState({}, "", url.toString());
            },
            deep: true
        }
    },
    methods: {
        loadSection() {
            this.xmlIdsQuery = {
                xmlIds: this.xmlIdsInput,
                userTierEmulation: this.userTierSelectedOption
            };
        },
        setLoading(value) {
            this.isLoading = value;
        }
    }
};
</script>

<style scoped lang="scss">
</style>